<template>
    <div>
        <hts-router-drawer
            ref="drawerEditQuote"
            :title="$t('labels.editQuote')"
            :size="90"
            :submit="handleEditQuote"
            :rules="cRules"
            @loaded="getData"
            @refreshTables="refreshTables">
            <div
                v-if="!loading"
                :style="{ minWidth: minWidthScroll }">
                <div
                    v-if="page === 0"
                    class="flex flex-col">
                    <ViewInformation
                        :data-create-quote="dataEditQuote"
                        type="edit"
                        @loaded="getData" />
                    <view-quote-price :data-create-quote="dataEditQuote">
                        <hts-form-button
                            icon-name="hi-pencil-square-icon"
                            color="info"
                            :btn-outline="false"
                            type="button"
                            :loading="loadingViewQuote"
                            @click="editPricingSelling">
                            {{ $t('labels.editPricingSelling') }}
                        </hts-form-button>
                    </view-quote-price>
                </div>
                <div v-else>
                    <add-quote
                        ref="addQuote"
                        show-request-price
                        type="edit"
                        :quote-request-id="dataQuote?.quoteRequestData?.quoteRequest"
                        :data-edit-quote="dataEditQuote"
                        :show-modal-alert="true"
                        :quote-data="dataQuote" />
                </div>
            </div>
            <template #footer>
                <template v-if="page === 0">
                    <div class="flex flex-row gap-5">
                        <hts-form-button
                            icon-name="hi-check-icon"
                            icon-position="right"
                            color="primary"
                            type="submit"
                            :loading="loadingEditQuote">
                            {{ $t('labels.save') }}
                        </hts-form-button>
                        <hts-form-button
                            icon-name="hi-x-mark-icon"
                            icon-position="right"
                            color="error"
                            @click="drawerEditQuote && drawerEditQuote.handleSubmitClose()">
                            {{ $t('labels.close') }}
                        </hts-form-button>
                    </div>
                </template>
                <template v-else>
                    <hts-form-button
                        icon-name="hi-arrow-long-left-icon"
                        color="primary"
                        @click="!(addQuote && addQuote.step === 0) ? addQuote && addQuote.previousStep() : (page = 0)">
                        {{ $t('labels.back') }}
                    </hts-form-button>
                    <div
                        v-if="addQuote && addQuote.step === 2"
                        class="flex">
                        <hts-form-button
                            class="ml-5"
                            icon-name="hi-arrow-long-right-icon"
                            icon-position="right"
                            color="primary"
                            :loading="loadingEditQuote"
                            @click="handleEditQuote">
                            {{ $t('labels.save') }}
                        </hts-form-button>
                    </div>
                    <hts-form-button
                        v-if="addQuote && addQuote.step < 2"
                        icon-name="hi-arrow-long-right-icon"
                        icon-position="right"
                        color="primary"
                        @click="addQuote && addQuote.nextStep()">
                        {{ $t('labels.next') }}
                    </hts-form-button>
                </template>
            </template>
        </hts-router-drawer>
    </div>
</template>

<script lang="ts" setup>
import AddQuote from '../../-components/add.vue'
import ViewInformation from '../../-components/information.vue'
import ViewQuotePrice from '../../-components/view-quote-price.vue'
import { IQuote } from '../../quote-request/-components/ignore/imports/form'
import { addQuote as IAddQuote } from '~/pages/trucker-[id]/quote/-components/ignore/imports/form'
// import pageTabs from '~/data/page-tabs/tabs.json'
import { $api } from '#imports'

import screen from '~/components/utils/screen'

const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm + 100}px`
})

const page = ref(0)
const addQuote = ref()
const dataEditQuote = ref<IAddQuote>({
  informationEditorPricingSelling: {
    pricingRequest: null,
    tempPricingRequest: null,
    commission: null,
    duration: null,
    priceIncrementLevel: null
  },
  workflow: '',
  positions: [],
  transportation: '',
  mergeContainer: false,
  headContainer: false,
  priceOfflineFee: [],
  customerName: '',
  customer: '',
  contact: '',
  contactName: '',
  contactPhone: '',
  contactEmail: '',
  policy: {
    freeHourNumber: 0,
    moocKeepHourly: 0,
    moocKeepOvernight: 0,
    calculatedByHourNextDay: '',
    moocKeepLongTerm: 0,
    calculatedFromEvening: 0,
    towingContainerSunday: 0,
    towingContainerHoliday: 0,
    reeferPluginChargesGenerator: 0
  },
  customerService: {
    id: '',
    name: '',
    phone: ''
  },
  abstemious: {
    id: '',
    name: '',
    phone: ''
  },
  groupEmail: '',
  compensationCost: null,
  exceptCompensationCost: '',
  charges: [],
  cooperatorDetail: null,
  contactDetail: null,
  dataConfig: {
    duration: 0,
    commission: 0,
    corporateIncomeTax: 0,
    monthlyInterest: 0,
    priceGasOline: 0,
    incrementLevel: 0,
    markup: 0
  },
  status: 0,
  effectiveFromDate: '',
  effectiveToDate: '',
  quoteTempSaveId: '',
  statusApprovalMarkup: null,
  minMarkupConfirm: null,
  markupAvailable: false
})
const emits = defineEmits(['refreshTables'])
const refreshTables = () => {
  emits('refreshTables')
}
const drawerEditQuote = ref()
const loading = ref(false)
const quoteId = computed(() => useRoute().params.idquote)
const getData = () => {
  loading.value = true
  const api = $url.quote.detail
  $api(api, { uriParams: { ID: quoteId.value } })
    .then((data: any) => {
      const resData: any = data.data.value
      if (resData.success) {
        Object.assign(dataEditQuote.value, { ...resData.data })
        dataEditQuote.value.contName = dataEditQuote.value.contCategory ? listLabelCont[dataEditQuote.value.contCategory] : ''
      }
      nextTick(() => {
        loading.value = false
      })
    })
    .catch(() => {
      loading.value = false
    })
}

// const route = useRoute()
// onBeforeMount(() => {
//   route.meta.pageTabs = pageTabs?.quote || []
// })

const dataQuote = ref<IQuote>()
const loadingViewQuote = ref(false)
const editPricingSelling = async () => {
  try {
    loadingViewQuote.value = true
    const api = $url.quote.getQuoteDataEdit
    const data: any = await $api(api, { uriParams: { ID: quoteId.value } })
    const resData = data?.data?.value
    if (resData && resData.success) {
      dataQuote.value = resData.data
      page.value = 1
    }
    loadingViewQuote.value = false
  } catch (e) {
    loadingViewQuote.value = false
  }
}

const loadingEditQuote = ref(false)
const handleEditQuote = async () => {
  loadingEditQuote.value = true
  try {
    let modifyDataEditQuote: { [key: string]: any } = {}
    if (page.value === 0) {
      modifyDataEditQuote = Object.assign(
        {
          priceOfflineFeeIds: $lodash.map(dataEditQuote.value.priceOfflineFee, '_id'),
          chargeIds: $lodash.map(dataEditQuote.value.charges, '_id')
        },
        {
          ...$lodash.pick(
            $lodash.cloneDeep(dataEditQuote.value),
            'abstemious',
            'customerService',
            'groupEmail',
            'compensationCost',
            'exceptCompensationCost',
            'status',
            'informationEditorPricingSelling',
            'positions',
            'effectiveFromDate',
            'effectiveToDate',
            'policy'
          )
        }
      ) // only data
    } else if (page.value === 1) {
      dataEditQuote.value.charges = addQuote.value.reformatCharges(addQuote.value.dataPositionsPricing)
      dataEditQuote.value.priceOfflineFee = addQuote.value.reformatCharges(dataEditQuote.value.priceOfflineFee)
      // dataEditQuote.value.comfirmRouteGGMap = addQuote.value.dataCreateQuote.comfirmRouteGGMap
      modifyDataEditQuote = Object.assign(
        {
          priceOfflineFeeIds: $lodash.map(dataEditQuote.value.priceOfflineFee, '_id'),
          chargeIds: $lodash.map(dataEditQuote.value.charges, '_id')
          // comfirmRouteGGMap: addQuote.value.dataCreateQuote?.comfirmRouteGGMap || false
        },
        {
          ...$lodash.pick(
            $lodash.cloneDeep(dataEditQuote.value),
            'abstemious',
            'customerService',
            'groupEmail',
            'compensationCost',
            'exceptCompensationCost',
            'status',
            'informationEditorPricingSelling',
            'positions',
            'effectiveFromDate',
            'effectiveToDate',
            'comfirmRouteGGMap',
            'policy'
          )
        }
      )
    }
    const api = $url.quote.editQuote
    const data: any = await $api(api, { uriParams: { ID: quoteId.value }, body: modifyDataEditQuote })
    const resData = data?.data?.value
    if (resData && resData.success) {
      process.client && $toast().success($t('labels.editQuoteSuccess'))
      drawerEditQuote.value && drawerEditQuote.value.handleSubmitClose()
    }
    loadingEditQuote.value = false
  } catch (e: any) {
    loadingEditQuote.value = false
  }
}

const listLabelCont: { [key: number]: any } = {
  10: $t('labels.vehicleModule.10ft'),
  20: $t('labels.vehicleModule.20ft'),
  40: $t('labels.vehicleModule.40ft'),
  45: $t('labels.vehicleModule.45ft'),
  50: $t('labels.vehicleModule.other')
}

const ruleCreateQuote = {
  effectiveFromDate: 'required|min_date:1970-01-01',
  effectiveToDate: 'min_date:1970-01-01'
}
const cRules = computed(() => {
  if (addQuote.value && addQuote.value.step === 2 && addQuote.value.dataCreateQuote.effectiveFromDate) {
    // validate khi chỉnh sửa giá
    const rules: { [key: string]: any } = $lodash.cloneDeep(ruleCreateQuote)

    const date = addQuote.value.dataCreateQuote.effectiveFromDate ? new Date(addQuote.value.dataCreateQuote.effectiveFromDate) : ''
    if (date && addQuote.value.dataCreateQuote.effectiveToDate) {
      date.setDate(date.getDate() + 1)
      rules.effectiveToDate = rules.effectiveToDate + `|min_date:${date.toISOString().split('T')[0]}`
    }
    return rules
  }
  if (page.value === 0) {
    // validate khi xem chi tiết
    const rules: { [key: string]: any } = $lodash.cloneDeep(ruleCreateQuote)
    const date = dataEditQuote.value.effectiveFromDate ? new Date(dataEditQuote.value.effectiveFromDate) : ''
    if (date && dataEditQuote.value.effectiveToDate) {
      date.setDate(date.getDate() + 1)
      rules.effectiveToDate = rules.effectiveToDate + `|min_date:${date.toISOString().split('T')[0]}`
    }
    return rules
  }
  return {}
})
</script>

<style scoped></style>
